<div class="drive-content" (click)="onContentBackgroundClick($event)">
  <div *ngIf="isDriveSearch" class="drive-search-banner">
    <span nz-icon nzType="search" nzTheme="outline" class="drive-search-banner-icon"></span>
    <span class="drive-search-banner-text">
      搜索结果：「{{ searchKeyword }}」
      <span *ngIf="totalNum > 0" class="drive-search-banner-count">共 {{ totalNum }} 项</span>
    </span>
  </div>

  <div *ngIf="!isDriveSearch" class="drive-breadcrumb">
    <a class="drive-breadcrumb-link" (click)="onRootBreadcrumbClick()">根目录</a>
    <ng-container *ngFor="let item of breadcrumb; let i = index">
      <span class="drive-breadcrumb-sep"> / </span>
      <a class="drive-breadcrumb-link" (click)="onBreadcrumbClick(i)">{{ item.name }}</a>
    </ng-container>
  </div>

  <div *ngIf="showSelectionToolbar" class="drive-selection-toolbar">
    <span class="drive-selection-toolbar-count" *ngIf="hasSelection">
      已选 {{ selectedCount }} 项
    </span>
    <span class="drive-selection-toolbar-count" *ngIf="!hasSelection && hasClipboard">
      剪贴板中有内容
    </span>
    <div class="drive-selection-toolbar-actions">
      <button
        *ngIf="canCopySelection"
        nz-button
        nzSize="small"
        nz-tooltip
        nzTooltipTitle="复制"
        (click)="emitToolbarAction('copy')"
      >
        <span nz-icon nzType="copy" nzTheme="outline"></span>
        复制
      </button>
      <button
        nz-button
        nzSize="small"
        [disabled]="!canCutSelection"
        nz-tooltip
        nzTooltipTitle="剪切"
        (click)="emitToolbarAction('cut')"
      >
        <span nz-icon nzType="scissor" nzTheme="outline"></span>
        剪切
      </button>
      <button
        nz-button
        nzSize="small"
        [disabled]="!canPaste"
        nz-tooltip
        nzTooltipTitle="粘贴到当前文件夹"
        (click)="emitToolbarAction('paste')"
      >
        <span nz-icon nzType="snippets" nzTheme="outline"></span>
        粘贴
      </button>
      <button
        nz-button
        nzSize="small"
        [disabled]="!canMoveSelection"
        nz-tooltip
        nzTooltipTitle="移动到..."
        (click)="emitToolbarAction('move')"
      >
        <span nz-icon nzType="export" nzTheme="outline"></span>
        移动
      </button>
    </div>
  </div>

  <div *ngIf="state === 'loading'" class="drive-state">
    <nz-spin nzSimple></nz-spin>
  </div>

  <div *ngIf="state === 'error'" class="drive-state drive-error">
    <span>{{ filesLoadError || '加载失败' }}</span>
    <button nz-button nzType="link" (click)="retryFiles.emit()">重试</button>
  </div>

  <div *ngIf="state === 'empty'" class="drive-state drive-empty">
    <span *ngIf="isDriveSearch && searchKeyword?.trim()">未找到「{{ searchKeyword }}」相关搜索资源</span>
    <span *ngIf="!isDriveSearch && searchKeyword?.trim()">未找到「{{ searchKeyword }}」相关资源</span>
    <span *ngIf="!searchKeyword?.trim()">暂无内容</span>
  </div>

  <ng-container *ngIf="state === 'ready'">
    <div class="drive-cards" *ngIf="folderCards.length && !isDriveSearch">
      <div class="drive-section-title">文件夹</div>
      <div
        class="drive-card-grid drive-card-grid--mixed"
        cdkDropList
        cdkDropListOrientation="mixed"
        [cdkDropListData]="folderCards"
        (cdkDropListDropped)="onFolderDrop($event)"
      >
        <div
          class="drive-folder-card"
          [class.drive-card--selected]="isFolderSelected(folder.id)"
          *ngFor="let folder of folderCards; trackBy: trackFolderById"
          cdkDrag
          (click)="onFolderCardClick(folder, $event)"
          (dblclick)="onFolderCardDblClick(folder)"
        >
          <span
            class="drive-drag-handle"
            cdkDragHandle
            nz-icon
            nzType="unordered-list"
            nzTheme="outline"
            (click)="$event.stopPropagation()"
          ></span>
          <button
            nz-button
            nzType="text"
            nzSize="small"
            class="drive-file-menu"
            nz-dropdown
            [nzDropdownMenu]="folderMenu"
            nzTrigger="click"
            (click)="$event.stopPropagation()"
          >
            <span nz-icon nzType="more"></span>
          </button>
          <nz-dropdown-menu #folderMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="emitFolderAction('edit', folder)">编辑</li>
              <li nz-menu-item (click)="emitFolderAction('move', folder)">移动</li>
              <li nz-menu-item (click)="emitFolderAction('toggleEnabled', folder)">
                {{ getFolderToggleEnabledLabel(folder) }}
              </li>
            </ul>
          </nz-dropdown-menu>
          <div
            class="drive-folder-icon-wrap"
            [attr.title]="folder.name"
            [class.drive-folder-icon-wrap--disabled]="shouldShowFolderStatus(folder)"
          >
            <span
              nz-icon
              nzType="folder"
              nzTheme="fill"
              class="drive-folder-icon"
            ></span>
            <span
              *ngIf="shouldShowFolderStatus(folder)"
              class="drive-folder-status drive-file-status"
              [class.drive-file-status--disabled]="folder.enabled === 0"
              [class.drive-file-status--processing]="folder.enabled === -1"
              nz-tooltip
              [nzTooltipTitle]="getFolderStatusLabel(folder)"
            >
              <span *ngIf="folder.enabled === 0" nz-icon nzType="stop" nzTheme="fill"></span>
              <span *ngIf="folder.enabled === -1" nz-icon nzType="loading" [nzSpin]="true"></span>
            </span>
          </div>
          <span class="drive-card-name" [attr.title]="folder.name">{{ folder.name }}</span>
        </div>
      </div>
    </div>

    <div class="drive-cards" *ngIf="fileCards.length">
      <div class="drive-section-title">
        <span *ngIf="isDriveSearch">搜索资源</span>
        <span *ngIf="!isDriveSearch">文件</span>
      </div>

      <div
        *ngIf="canSortFiles"
        class="drive-card-grid drive-card-grid--mixed"
        cdkDropList
        cdkDropListOrientation="mixed"
        [cdkDropListData]="sortableFileCards"
        (cdkDropListDropped)="onFileDrop($event)"
      >
        <div
          class="drive-file-card"
          [class.drive-card--selected]="isFileSelected(file.id)"
          *ngFor="let file of sortableFileCards; trackBy: trackFileById"
          cdkDrag
          (click)="onFileCardClick(file, $event)"
          (dblclick)="onFileCardDblClick(file)"
        >
          <span
            class="drive-drag-handle"
            cdkDragHandle
            nz-icon
            nzType="unordered-list"
            nzTheme="outline"
            (click)="$event.stopPropagation()"
          ></span>
          <ng-container *ngTemplateOutlet="fileCardMenu; context: { $implicit: file }"></ng-container>
          <ng-container *ngTemplateOutlet="fileCardCover; context: { $implicit: file }"></ng-container>
          <span class="drive-card-name" [attr.title]="file.name">{{ file.name }}</span>
          <span
            *ngIf="isDriveSearch && getPrimaryFolderLabel(file)"
            class="drive-card-folder"
            [attr.title]="getPrimaryFolderLabel(file)"
          >{{ getPrimaryFolderLabel(file) }}</span>
        </div>
      </div>

      <div *ngIf="!canSortFiles" class="drive-card-grid">
        <div
          class="drive-file-card"
          [class.drive-card--selected]="isFileSelected(file.id)"
          *ngFor="let file of fileCards; trackBy: trackFileById"
          (click)="onFileCardClick(file, $event)"
          (dblclick)="onFileCardDblClick(file)"
        >
          <ng-container *ngTemplateOutlet="fileCardMenu; context: { $implicit: file }"></ng-container>
          <ng-container *ngTemplateOutlet="fileCardCover; context: { $implicit: file }"></ng-container>
          <span class="drive-card-name" [attr.title]="file.name">{{ file.name }}</span>
          <span
            *ngIf="isDriveSearch && getPrimaryFolderLabel(file)"
            class="drive-card-folder"
            [attr.title]="getPrimaryFolderLabel(file)"
          >{{ getPrimaryFolderLabel(file) }}</span>
        </div>
      </div>
    </div>

    <ng-template #fileCardCover let-file>
      <div
        class="drive-file-cover-wrap"
        [attr.title]="file.name"
        [class.drive-file-cover-wrap--disabled]="shouldShowFileStatus(file) && file.enabled === 0"
      >
        <div
          class="drive-file-cover"
          [ngStyle]="{ 'background-image': file.coverUrl ? 'url(' + file.coverUrl + ')' : 'none' }"
        ></div>
        <span
          *ngIf="shouldShowFileStatus(file)"
          class="drive-file-status"
          [class.drive-file-status--disabled]="file.enabled === 0"
          [class.drive-file-status--processing]="file.enabled === -1"
          nz-tooltip
          [nzTooltipTitle]="getFileStatusLabel(file)"
        >
          <span *ngIf="file.enabled === 0" nz-icon nzType="stop" nzTheme="fill"></span>
          <span *ngIf="file.enabled === -1" nz-icon nzType="loading" [nzSpin]="true"></span>
        </span>
      </div>
    </ng-template>

    <ng-template #fileCardMenu let-file>
      <button
        nz-button
        nzType="text"
        nzSize="small"
        class="drive-file-menu"
        nz-dropdown
        [nzDropdownMenu]="fileMenu"
        nzTrigger="click"
        (click)="$event.stopPropagation()"
      >
        <span nz-icon nzType="more"></span>
      </button>
      <nz-dropdown-menu #fileMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="emitFileAction('view', file)">查看詳細</li>
          <li nz-menu-item (click)="emitFileAction('edit', file)">編輯</li>
          <li nz-menu-item (click)="emitFileAction('rename', file)">重命名</li>
          <li nz-menu-item (click)="emitFileAction('move', file)">移动</li>
          <li
            nz-menu-item
            [nzDisabled]="!canToggleFileEnabled(file)"
            (click)="emitFileAction('toggleEnabled', file)"
          >
            {{ getFileToggleEnabledLabel(file) }}
          </li>
          <li
            nz-menu-item
            *ngFor="let locateFolder of getLocateFolders(file)"
            [nzDisabled]="isCurrentLocateFolder(locateFolder)"
            (click)="emitFileAction('locateFolder', file, { folderId: locateFolder.folderId })"
          >
            所在文件夹：{{ getFolderLabel(locateFolder) }}
          </li>
          <li nz-menu-item *ngIf="showCopyAction" (click)="emitFileAction('copy', file)">复制</li>
          <li
            nz-menu-item
            nzDanger
            [nzDisabled]="!canRemoveFromFolder(file)"
            (click)="emitFileAction('removeFromFolder', file, { folderId: getRemoveFromFolderId(file) ?? undefined })"
          >
            从文件夹删除
          </li>
          <li nz-menu-item nzDanger (click)="emitFileAction('delete', file)">删除文件</li>
        </ul>
      </nz-dropdown-menu>
    </ng-template>

    <div class="drive-pagination" *ngIf="totalNum > pageSize">
      <nz-pagination
        [nzPageIndex]="pageIndex"
        [nzPageSize]="pageSize"
        [nzTotal]="totalNum"
        [nzShowSizeChanger]="true"
        [nzPageSizeOptions]="[10, 15, 20, 50]"
        (nzPageIndexChange)="onPageIndexChange($event)"
        (nzPageSizeChange)="onPageSizeChange($event)"
      ></nz-pagination>
    </div>
  </ng-container>
</div>
